import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { service_socketio_client } from '@/services/socketio_client_react/service_socketio_client';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_RESPONSE__auth_success } from '@shared/dto/+user/auth/_requests/response_auth_success';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { StateUser } from '../../state_user';
import { try_set_is_authorized } from '../_methods/try_set_is_authorized';

export const remote_user_auth_login_with_token = createAsyncThunkSafe<DTO_RESPONSE__auth_success | DTO_RESPONSE__error, string>(
  ENUM__network_event_client_to_server.USER_AUTH_LOGIN_WITH_TOKEN,
  async (auth_token): Promise<DTO_RESPONSE__auth_success | DTO_RESPONSE__error> => {
    let response = await send_to_server<DTO_RESPONSE__auth_success | DTO_RESPONSE__error>(
      ENUM__network_event_client_to_server.USER_AUTH_LOGIN_WITH_TOKEN,
      auth_token,
    );

    return response;
  },
);

export function init_remote_user_auth_login_with_token(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(remote_user_auth_login_with_token.pending, state => {
      //do nothing
    })
    .addCase(remote_user_auth_login_with_token.rejected, (state, action) => {
      state.auth_token = '';
      service_socketio_client.is_connection_authorized = false;
    })
    .addCase(remote_user_auth_login_with_token.fulfilled, (state, action: PayloadAction<DTO_RESPONSE__auth_success | DTO_RESPONSE__error>) => {
      // The connection state is now managed by the Redux store
      // and updated through the socketService's event listeners
      // So we don't need to set it here
      try_set_is_authorized(state, action.payload);
    });
}
